/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SaveFleetMutationVariables = Types.Exact<{
  input: Types.FleetInput;
}>;


export type SaveFleetMutation = {
  __typename?: 'Mutation',
  saveFleet: {
    __typename?: 'Fleet',
    id: number
  }
};

export type DeleteFleetMutationVariables = Types.Exact<{
  fleetId: Types.Scalars['Long']['input'];
}>;


export type DeleteFleetMutation = {
  __typename?: 'Mutation',
  deleteFleet?: string | null
};

export type RemoveShipFromFleetMutationVariables = Types.Exact<{
  fleetId: Types.Scalars['Long']['input'];
  shipId: Types.Scalars['Long']['input'];
}>;


export type RemoveShipFromFleetMutation = {
  __typename?: 'Mutation',
  removeShipFromFleet: {
    __typename?: 'Fleet',
    id: number,
    description: string,
    ships?: Array<{
      __typename?: 'Ship',
      id: number,
      name: string,
      eni?: string | null,
      mmsi?: number | null
    }> | null
  }
};

export type AddShipToFleetMutationVariables = Types.Exact<{
  fleetId: Types.Scalars['Long']['input'];
  shipId: Types.Scalars['Long']['input'];
}>;


export type AddShipToFleetMutation = {
  __typename?: 'Mutation',
  addShipToFleet: {
    __typename?: 'Fleet',
    id: number,
    description: string,
    ships?: Array<{
      __typename?: 'Ship',
      id: number,
      name: string,
      eni?: string | null,
      mmsi?: number | null
    }> | null
  }
};


export const SaveFleetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFleet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FleetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveFleet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveFleetMutation, SaveFleetMutationVariables>;
export const DeleteFleetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFleet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFleet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fleetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}}}]}]}}]} as unknown as DocumentNode<DeleteFleetMutation, DeleteFleetMutationVariables>;
export const RemoveShipFromFleetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveShipFromFleet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeShipFromFleet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fleetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveShipFromFleetMutation, RemoveShipFromFleetMutationVariables>;
export const AddShipToFleetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddShipToFleet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addShipToFleet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fleetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fleetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}}]}}]}}]}}]} as unknown as DocumentNode<AddShipToFleetMutation, AddShipToFleetMutationVariables>;